<template>
<div>
    <v-card>
        <v-card-title>
            <h5 class="headline">Create Teacher</h5>
        </v-card-title>

        <v-card-text>
            <div v-if="laravelErrors.active" class="text-xs-center">
                <v-chip v-for="(msg,key) in laravelErrors.messages" :key="key" label color="red" text-color="white">{{ msg[0] }}
                </v-chip>
            </div>

            <v-form>
                <v-text-field name="first_name" label="First Name" v-model="first_name" v-validate="'required|alpha_spaces'"></v-text-field>
                <span class="error--text">{{ errors.first('first_name') }}</span>
                <v-text-field label="Last Name" v-model="last_name" name="last_name" v-validate="'required|alpha_spaces'"></v-text-field>
                <span class="error--text">{{ errors.first('last_name') }}</span>
                <v-text-field label="Email" v-model="email" name="email" v-validate="'required|email'"></v-text-field>
                <span class="error--text">{{ errors.first('email') }}</span>
            </v-form>
        </v-card-text>

        <v-card-actions class="pb-3">
            <v-spacer></v-spacer>
            <v-btn color="blue white--text" small @click="close">Cancel</v-btn>
            <v-btn color="blue white--text" small @click="save">Save</v-btn>
        </v-card-actions>
    </v-card>

    <v-dialog v-model="successAlert" max-width="500px">
        <v-card>
            <v-card-text>
                <v-alert :value="true" type="success">Teacher successfully added!</v-alert>
            </v-card-text>
            <v-card-actions>
                <v-btn flat color="primary" @click="successAlert = false">Close</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

</div>
</template>

<script>
export default {
    props: ['active'],
    data() {
        return {
            first_name: '',
            last_name: '',
            email: '',
            successAlert: false,
            laravelErrors: {
                active: false,
                messages: []
            }
        }
    },
    computed: {

    },
    watch: {
        'active': function (value) {
            if (!value) {
                this.clearErrors()
                this.errors.clear()
                this.first_name = '',
                    this.last_name = ''
                this.email = ''
            }
        }
    },
    methods: {
        save() {
            this.$validator.validateAll().then((response) => {
                if (response) {
                    let payload = {
                        first_name: this.first_name,
                        last_name: this.last_name,
                        email: this.email,
                    }
                    this.$store.dispatch('createTeacher', payload).then((r) => {
                            this.clearErrors()
                            this.successAlert = true
                            this.$emit('close')
                        })
                        .catch((e) => {
                            this.laravelErrors.active = true
                            this.laravelErrors.messages = e.response.data.errors
                        })
                }
            })
        },
        clearErrors() {
            this.laravelErrors.active = false
            this.laravelErrors.messages = []
        },
        close() {
            this.$emit('close')
        }
    },
    created() {
        window.addEventListener('keydown', this.clearErrors)
    },
    destroyed() {
        window.removeEventListener('keydown', this.clearErrors)
    }
}
</script>
